<template>
  <svg
    class="iconfont"
    aria-hidden="true"
    :style="style">
    <use :xlink:href="'#icon-' + name"/>
  </svg>
</template>

<script>
export default {
  name: 'Icon',
  props: {
    name: {
      type: String,
      required: true
    },
    color: {
      type: String,
      default: 'inherit'
    }
  },
  computed: {
    style () {
      return {
        color: this.color
      }
    }
  }
}
</script>

<style lang="scss">
.iconfont {
  width: 1em; 
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
</style>